import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import LazyLoad from 'react-lazyload';

import Image from './Image';

const Wrapper = styled(({ baseUrl, bgColor, ...rest }) => <div {...rest} />)`
  width: 100%;
  height: 100%;
  position: relative;
  background-size: 100% 100%;
  ${props => props.bgColor && `background-color: ${props.bgColor};`}
  ${props => props.baseUrl && `background-image: url(${props.baseUrl});`};
`;

const LazyImage = ({
  className,
  imageClass,
  altImage,
  lazyUrl,
  baseUrl,
  bgColor,
  bgposition,
  children,
  /*
    the image will be loaded when it's top edge is 150px
  */
  offset,
  imageProps,
  lazyLoadProps,
  ...rest
}) => (
  <Wrapper className={className} baseUrl={baseUrl} bgColor={bgColor} {...rest}>
    <LazyLoad
      offset={offset}
      /* Set height properly will make LazyLoad calculate more precisely (performance) */
      height={160}
      placeholder={
        <div
          style={{
            height: 160,
            position: 'absolute',
            top: 0,
            right: 0,
            left: 0,
            bottom: 0,
          }}
        />
      }
      {...lazyLoadProps}
    >
      <Image
        imageClass={imageClass}
        bg={lazyUrl}
        bgposition={bgposition}
        altImage={altImage}
        {...imageProps}
      />
    </LazyLoad>
    {children}
  </Wrapper>
);

LazyImage.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  imageClass: PropTypes.string,
  altImage: PropTypes.string,
  bgColor: PropTypes.string,
  baseUrl: PropTypes.string,
  lazyUrl: PropTypes.string.isRequired,
  bgposition: PropTypes.string,
  offset: PropTypes.number,
  imageProps: PropTypes.shape({}),
  lazyLoadProps: PropTypes.shape({}),
};

LazyImage.defaultProps = {
  bgsize: 'cover',
  bgposition: 'center',
  bgColor: '',
  className: '',
  baseUrl: '',
  lazyUrl: '',
  offset: 360,
  imageProps: {},
  imageClass: '',
  altImage: '',
  children: null,
  lazyLoadProps: {},
};

export default LazyImage;
